module.exports = __webpack_public_path__ + "img/ly.d84f64c7.svg";